import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ProfileHeader = ({ profile, isOwnProfile, onEditClick, onPhotoClick }) => {
  return (
    <div className="bg-card rounded-lg shadow-elevation-2 p-6 md:p-8">
      <div className="flex flex-col md:flex-row items-start md:items-center space-y-6 md:space-y-0 md:space-x-8">
        {/* Profile Photo */}
        <div className="relative">
          <div 
            className={`w-32 h-32 md:w-40 md:h-40 rounded-full overflow-hidden border-4 border-border ${
              isOwnProfile ? 'cursor-pointer hover:opacity-80 transition-opacity' : ''
            }`}
            onClick={isOwnProfile ? onPhotoClick : undefined}
          >
            {profile?.profilePhotoUrl ? (
              <Image
                src={profile?.profilePhotoUrl}
                alt={`${profile?.fullName}'s profile photo`}
                className="w-full h-full object-cover"
              />
            ) : (
              <div className="w-full h-full bg-muted flex items-center justify-center">
                <Icon name="User" size={64} className="text-muted-foreground" />
              </div>
            )}
          </div>
          
          {/* Verified Badge */}
          {profile?.verifiedStatus && (
            <div className="absolute -bottom-2 -right-2 w-12 h-12 bg-success rounded-full flex items-center justify-center border-4 border-card shadow-lg">
              <Icon name="CheckCircle2" size={24} color="white" strokeWidth={2.5} />
            </div>
          )}

          {/* Upload Icon for Own Profile */}
          {isOwnProfile && (
            <div className="absolute bottom-2 right-2 w-10 h-10 bg-primary rounded-full flex items-center justify-center border-2 border-card shadow-lg cursor-pointer hover:bg-primary/90 transition-colors">
              <Icon name="Camera" size={18} color="white" />
            </div>
          )}
        </div>

        {/* Profile Info */}
        <div className="flex-1">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-4">
            <div>
              <div className="flex items-center space-x-3 mb-2">
                <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground">
                  {profile?.fullName}
                </h1>
                {profile?.verifiedStatus && (
                  <span className="px-3 py-1 bg-success/10 text-success text-sm font-caption font-semibold rounded-full">
                    Verified
                  </span>
                )}
              </div>
              <p className="font-body text-lg text-muted-foreground capitalize">
                {profile?.role}
              </p>
            </div>

            {isOwnProfile && (
              <Button
                variant="outline"
                size="md"
                iconName="Edit"
                iconPosition="left"
                onClick={onEditClick}
                className="mt-4 sm:mt-0"
              >
                Edit Profile
              </Button>
            )}
          </div>

          {/* Location */}
          {(profile?.city || profile?.state) && (
            <div className="flex items-center space-x-2 mb-4">
              <Icon name="MapPin" size={20} className="text-primary" strokeWidth={2} />
              <span className="font-body text-base text-foreground">
                {profile?.city}{profile?.city && profile?.state ? ', ' : ''}{profile?.state}
              </span>
            </div>
          )}

          {/* Bio */}
          {profile?.bio && (
            <div className="mt-4">
              <p className="font-body text-base text-muted-foreground leading-relaxed">
                {profile?.bio}
              </p>
            </div>
          )}

          {/* Contact Button for Other Users */}
          {!isOwnProfile && (
            <div className="mt-6">
              <Button
                variant="primary"
                size="lg"
                iconName="MessageCircle"
                iconPosition="left"
              >
                Contact User
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProfileHeader;